import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixQuickpagesMaterializedpagesV1MaterializedPagesUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {};

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_quick-pages_materialized-pages';

/** Retrieves a MaterializedPage. */
export function getMaterializedPage(
  payload: object
): RequestOptionsFactory<any> {
  function __getMaterializedPage({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.quickpages.materializedpages.v1.materialized_page',
      method: 'GET' as any,
      methodFqn:
        'wix.quickpages.materializedpages.v1.MaterializedPages.GetMaterializedPage',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixQuickpagesMaterializedpagesV1MaterializedPagesUrl({
        protoPath: '/v1/materialized-pages/{materializedPageId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'materializedPage.createdDate' },
              { path: 'materializedPage.updatedDate' },
              { path: 'materializedPage.publishedDate' },
              { path: 'materializedPage.unpublishedDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getMaterializedPage;
}

/** Retrieves a list of up to 100 materialized pages, given the specified filtering, search expression, sorting, and cursor paging ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language) | [REST](https://dev.wix.com/api/rest/getting-started/api-query-language)). */
export function searchMaterializedPages(
  payload: object
): RequestOptionsFactory<any> {
  function __searchMaterializedPages({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'search.aggregations.range.buckets.from' },
          { path: 'search.aggregations.range.buckets.to' },
          {
            path: 'search.aggregations.nested.nestedAggregations.range.buckets.from',
          },
          {
            path: 'search.aggregations.nested.nestedAggregations.range.buckets.to',
          },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.quickpages.materializedpages.v1.materialized_page',
      method: 'POST' as any,
      methodFqn:
        'wix.quickpages.materializedpages.v1.MaterializedPages.SearchMaterializedPages',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixQuickpagesMaterializedpagesV1MaterializedPagesUrl({
        protoPath: '/v1/materialized-pages/search',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'materializedPages.createdDate' },
              { path: 'materializedPages.updatedDate' },
              { path: 'materializedPages.publishedDate' },
              { path: 'materializedPages.unpublishedDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'aggregationData.results.ranges.results.from' },
              { path: 'aggregationData.results.ranges.results.to' },
              {
                path: 'aggregationData.results.groupedByValue.results.nestedResults.ranges.results.from',
              },
              {
                path: 'aggregationData.results.groupedByValue.results.nestedResults.ranges.results.to',
              },
              {
                path: 'aggregationData.results.nested.results.results.*.range.from',
              },
              {
                path: 'aggregationData.results.nested.results.results.*.range.to',
              },
              { path: 'aggregationData.results.scalar.value' },
              {
                path: 'aggregationData.results.groupedByValue.results.nestedResults.scalar.value',
              },
              {
                path: 'aggregationData.results.nested.results.results.*.scalar.value',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __searchMaterializedPages;
}
